//  Отступ от верхнего края страницы с учетом новой ширины хедера
export const PADDING_ADMIN_CONTAINER_WITH_TEST_MODE_BANNER = '94px';

//  Высота системного банера
export const TEST_MODE_BANNER_HEIGHT = '24px';

//  Новая ширина хедера для портала с учетом банера
export const HEADER_HEIGHT_PORTAL_WITH_TEST_MODE_BANNER = '94px';

//  Новая ширина toolbar для портала с учетом банера
export const TOOLBAR_HEIGHT_PORTAL_WITH_TEST_MODE_BANNER = '74px';
